<template>
  <div id="app">
    <body ontouchstart="">
    <background></background>
    <navbar></navbar>
    <router-view/>
    <foot></foot>
    </body>
  </div>
</template>

<script>
import Background from './components/Background.vue'
import Navbar from './components/Navbar.vue'
import Foot from './components/Footer.vue'

export default {
  name: 'app',
  components: {
    Background,
    Navbar,
    Foot
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?d8ede5ee